import BrokerGroupService from '@/services/bankwatch/BrokerGroupService';
import { BrokerGroupStatus } from '@/domain/bankwatch';

const brokerGroupService = new BrokerGroupService();

export const getGroups = async ({ commit }: { commit: Function }) => {
    commit('isFetching', true);
    try {
        commit('groups', await brokerGroupService.getGroups());
    } finally {
        commit('isFetching', false);
    }
}

export const createGroup = async (
    _ctx: any, payload: { name: string; status: BrokerGroupStatus }
) => {
    return await brokerGroupService.createGroup(payload.name, payload.status);
}

export const updateGroup = async (
    _ctx: any, payload: { groupId: string; updates: { name?: string; status?: BrokerGroupStatus } }
) => {
    return await brokerGroupService.updateGroup(payload.groupId, payload.updates);
}

export const getBrokers = async ({ commit }: { commit: Function }, groupId: string) => {
    commit('brokers', await brokerGroupService.getBrokers(groupId));
}

export const addBroker = async (
    _ctx: any, payload: { groupId: string; email: string; firstName?: string; lastName?: string }
) => {
    return await brokerGroupService.addBroker(payload.groupId, payload.email, payload.firstName, payload.lastName);
}

export const setBrokerAccess = async (
    _ctx: any, payload: { groupId: string; brokerId: string; enabled: boolean }
) => {
    return await brokerGroupService.setBrokerAccess(payload.groupId, payload.brokerId, payload.enabled);
}

export const getLenders = async ({ commit }: { commit: Function }) => {
    const lenders = await brokerGroupService.getLenders();
    commit('lenders', lenders);
    return lenders;
}

export const getPanel = async ({ commit }: { commit: Function }, groupId: string) => {
    const panel = await brokerGroupService.getPanel(groupId);
    commit('panel', panel.panelOrgIds || []);
    return panel;
}

export const setPanel = async (
    _ctx: any, payload: { groupId: string; orgIds: string[] }
) => {
    return await brokerGroupService.setPanel(payload.groupId, payload.orgIds);
}

export const getAudit = async ({ commit }: { commit: Function }, groupId: string) => {
    commit('audit', await brokerGroupService.getGroupAudit(groupId));
}
